// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"0f6a9399","142":"98be58c2","420":"22d1bf43","707":"fa714cb3","787":"734986f1","796":"b1343292"}[chunkId] + ".chunk.js";
};